module.exports = __webpack_public_path__ + "static/media/Lord Voldemort 2.218b1c18.jpg";